import { useEffect } from "react";

export default function JsonLd() {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://www.vaana.ai.in",
      "name": "Vaana BuildLogic Technologies",
      "description": "Vaana BuildLogic Technologies delivers enterprise IT solutions, ERP systems, cloud infrastructure, cybersecurity, AR/VR, AI/ML, IoT automation, multimedia production, 3D printing, and AMC/CMC services in New Delhi.",
      "url": "https://www.vaana.ai.in",
      "logo": "https://www.vaana.ai.in/vaana-logo.png",
      "image": "https://www.vaana.ai.in/vaana-og-image.jpg",
      "telephone": "+919953167073",
      "email": "info@vaanabuildlogictechnologies.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station",
        "addressLocality": "New Delhi",
        "addressRegion": "Delhi",
        "postalCode": "110044",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "28.5045",
        "longitude": "77.3028"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "priceRange": "$$",
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "28.5045",
          "longitude": "77.3028"
        },
        "geoRadius": "50000"
      },
      "serviceType": [
        "IT Services",
        "ERP Services",
        "Cloud Services",
        "IT Infrastructure",
        "Cyber Security",
        "Security and Surveillance",
        "AR/VR Solutions",
        "AI/ML and Deep Learning Solutions",
        "IoT Automation",
        "AMC/CMC Services",
        "3D Printing and Rapid Prototyping"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "IT Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IT Services",
              "description": "Custom software development, application management, and end-to-end IT consulting."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "ERP Services",
              "description": "Enterprise resource planning implementation, customization, and support."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Cloud Services",
              "description": "Cloud migration, managed hosting, and scalable infrastructure."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IT Infrastructure",
              "description": "Network design, data center solutions, and hardware provisioning."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Cyber Security",
              "description": "Threat assessment, vulnerability management, and compliance-ready security solutions."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Security & Surveillance",
              "description": "CCTV systems, access control, and integrated monitoring for physical security."
            }
          }
        ]
      },
      "sameAs": ["https://www.linkedin.com/company/vaana-buildlogictechnologies"]
    };

    const orgSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Vaana BuildLogic Technologies",
      "url": "https://www.vaana.ai.in",
      "logo": "https://www.vaana.ai.in/vaana-logo.png",
      "description": "Enterprise IT, ERP, Cloud, Cybersecurity, AR/VR, AI/ML, IoT and AMC/CMC services.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station",
        "addressLocality": "New Delhi",
        "postalCode": "110044",
        "addressCountry": "IN"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91 9953167073",
        "contactType": "customer service",
        "email": "info@vaanabuildlogictechnologies.com",
        "areaServed": "IN"
      },
      "sameAs": [
        "https://www.linkedin.com/company/vaana-buildlogictechnologies"
      ]
    };

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Vaana BuildLogic Technologies",
      "url": "https://www.vaana.ai.in"
    };

    // Inject all schemas
    const schemas = [schema, orgSchema, websiteSchema];
    const scriptElements = [];

    schemas.forEach((s, i) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(s);
      script.id = `json-ld-${i}`;
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    return () => {
      scriptElements.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, []);

  return null;
}
